<div class="full-breakdown">
	<ui-tab-bar
		[tabs]="tabs"
		[align]="'justify'"
		[starting_selected_index]="depositTabActive ? 0 : 1"
		(tab_change)="changeTab($event)"
	></ui-tab-bar>
	<div *ngIf="depositTabActive">
		<div class="heading align-center">
			<h1>Deposit Breakdown</h1>
			<p>Find out exactly how your deposit is being calculated</p>
		</div>

		<div class="content">
			<div id="cash-deposit">
				<div class="table">
					<div class="row header">
						<div class="col-xxs-30 col-header-title">
							Deposit Item
						</div>
					</div>
					<ul class="items">
						<ng-container *ngFor="let pex of part_exchanges">
							<li class="row">
								<div class="col-xxs-20 col-sm-20 col-item-title">
									<div class="item-title no-padding">
										<div class="item-title-text">
											{{ pex.vehicle.make }} {{ pex.vehicle.model }}
										</div>
										<div class="item-subtitle-text">
											{{ pex.vehicle.edition }}
										</div>
										<span class="number-plate">
											{{ pex.registration }}
										</span>
									</div>
								</div>
								<div class="col-xxs-10 col-sm-10 col-brand align-right">
									<span class="pex-value">{{ pex.vehicle.allowance | money }}</span>
									<span *ngIf="pex.vehicle.finance_settlement" class="settlement">
										<br />
										-{{ pex.vehicle.finance_settlement | money }}
									</span>
								</div>
							</li>
						</ng-container>
						<li class="row">
							<div class="col-xxs-20 col-sm-20 col-item-title">
								<div class="item-title no-padding">
									<div class="item-title-text">
										Cash Deposit
									</div>
								</div>
							</div>
							<div class="col-xxs-10 col-sm-10 col-brand align-right">
								{{ calculateCashDeposit() | money }}
							</div>
						</li>

						<li *ngFor="let addon of getNonFinanceableAddons()" class="row">
							<div class="col-xxs-20 col-sm-20 col-item-title">
								<div class="item-title no-padding">
									<div class="item-title-text">
										{{ addon.description }}
									</div>
								</div>
							</div>
							<div
								*ngIf="!vehicle.add_vat || !addon.vat"
								class="col-xxs-10 col-sm-10 col-brand align-right"
							>
								{{ addon.amount | money }}
							</div>
							<div
								*ngIf="vehicle.add_vat && addon.vat"
								class="col-xxs-10 col-sm-10 col-brand align-right"
							>
								{{ addon.net_amount | money }}
							</div>
						</li>

						<li *ngIf="configure_service.configure_data.steps.purchase_vehicle.data.add_vat" class="row">
							<div class="col-xxs-20 col-sm-20 col-item-title">
								<div class="item-title no-padding">
									<div class="item-title-text">
										Vehicle (VAT)
									</div>
								</div>
							</div>
							<div class="col-xxs-10 col-sm-10 col-brand align-right">
								{{ getTotalVatDeposit() | money }}
							</div>
						</li>

						<ng-template ngFor [ngForOf]="getVatableAddons()" let-vat_addon>
							<li *ngIf="vehicle.add_vat" class="row">
								<div class="col-xxs-20 col-sm-20 col-item-title">
									<div class="item-title no-padding">
										<div class="item-title-text">{{ vat_addon.description }} (VAT)</div>
									</div>
								</div>
								<div class="col-xxs-10 col-sm-10 col-brand align-right">
									{{ vat_addon.amount - vat_addon.net_amount | money }}
								</div>
							</li>
						</ng-template>
					</ul>
				</div>
			</div>

			<div id="total">
				<div class="table">
					<ul class="items">
						<li class="row">
							<div class="col-xxs-20 col-sm-20 col-item-title">
								<div class="item-title no-padding">
									<div class="item-title-text title">
										Total Contribution:
									</div>
								</div>
							</div>
							<div class="col-xxs-10 col-sm-10 col-brand align-right">
								{{ getSelectedQuote().total_deposit | money }}
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="financeTabActive">
		<div class="heading align-center">
			<h1>Finance Breakdown</h1>
			<p>Your monthly payment breakdown.</p>
		</div>

		<div class="content">
			<div class="table">
				<div class="row header">
					<div class="col-xxs-30 col-header-title">
						Finance Item
					</div>
				</div>
				<ul class="items">
					<li class="row">
						<div class="col-xxs-20 col-sm-20 col-item-title">
							<div class="item-title no-padding">
								<div class="item-title-text">
									First Payment
								</div>
							</div>
						</div>
						<div class="col-xxs-10 col-sm-10 col-brand align-right">
							<span>{{ quote.first_payment !== null ? (quote.first_payment | money) : 'TBC' }}</span>
						</div>
					</li>
					<li class="row">
						<div class="col-xxs-20 col-sm-20 col-item-title">
							<div class="item-title no-padding">
								<div class="item-title-text">
									{{
										quote.number_of_regular_payments !== null
											? quote.number_of_regular_payments + ' Regular Payments'
											: 'TBC'
									}}
								</div>
							</div>
						</div>
						<div class="col-xxs-10 col-sm-10 col-brand align-right">
							<span>{{ quote.regular_payment ? (quote.regular_payment | money) : 'TBC' }}</span>
						</div>
					</li>
					<li class="row">
						<div class="col-xxs-20 col-sm-20 col-item-title">
							<div class="item-title no-padding">
								<div class="item-title-text">
									Final Payment
								</div>
							</div>
						</div>
						<div class="col-xxs-10 col-sm-10 col-brand align-right">
							<span>{{ quote.final_payment !== null ? (quote.final_payment | money) : 'TBC' }}</span>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</div>
